import { useContext } from "react";
import { ValidationResult, validationResultBuilder } from "sprint-common-web";

import { useDeliveryApi } from "../../../common/api/delivery-api/useDeliveryApi";
import { OriginatorListingContext } from "../context/OriginatorListingContext";
import { OriginatorListingItem } from "../context/OriginatorListingItem";
import { CreateOriginatorFormInputs } from "./CreateOriginatorForm";

export const useCreateOriginatorForm = () => {
    const { createOriginator } = useDeliveryApi();
    const { allItems, add } = useContext(OriginatorListingContext);

    const validateName = (name: string | undefined): ValidationResult => {
        const resultsBuilder = validationResultBuilder();

        if (name) {
            const usedNames = allItems.map((originatorItem: OriginatorListingItem) =>
                originatorItem.name.toLowerCase()
            );

            if (usedNames.includes(name.toLowerCase())) {
                resultsBuilder.withError("This name is already taken");
            }
        }

        return resultsBuilder.build();
    };

    const create = async ({ name }: CreateOriginatorFormInputs): Promise<void> => {
        const response = await createOriginator({
            name
        });

        add({
            name,
            id: response.entityId,
            updatedDate: new Date(),
            isModified: true
        });
    };

    return {
        create,
        validateName
    };
};
